import { Card, Flex, Statistic, Typography } from "antd";
import { formatCurrencyWithNotation } from "@/utils/currency";
import { CSSProperties } from "react";
import { gray } from "@ant-design/colors";

interface StatisticCardProps {
  type?: "total" | "subtotal";
  title: string;
  value: number;
  percentage?: string;
  percentageColor?: CSSProperties["color"];
  showPercentage?: boolean;
  onClick?: () => void;
}

const StatisticCard = ({
  type = "subtotal",
  title,
  value,
  percentage = "0%",
  percentageColor,
  showPercentage = true,
  onClick,
}: StatisticCardProps) => {
  return (
    <Card
      variant="borderless"
      styles={{
        body: {
          padding: 16,
        },
      }}
      onClick={onClick}
      style={{
        cursor: onClick ? "pointer" : "default",
        height: "100%",
        // backgroundColor: type === "total" ? blue[1] : undefined,
      }}
    >
      <Statistic
        title={
          <Typography.Text
            style={{
              fontWeight: 400,
              textTransform: "capitalize",
              color: type === "total" ? gray[6] : gray[5],
            }}
          >
            {title.toLowerCase()}
          </Typography.Text>
        }
        valueStyle={{
          fontSize: 24,
          fontWeight: type === "total" ? 600 : 400,
          textWrap: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
        }}
        value={value}
        formatter={(value) => formatCurrencyWithNotation(value as number)}
        valueRender={(value) => (
          <Flex vertical gap={2}>
            {value}
            {showPercentage && (
              <Typography.Text
                style={{
                  color: percentageColor || "gray",
                  fontWeight: type === "total" ? 500 : 400,
                  fontSize: 12,
                }}
              >
                {percentage}
              </Typography.Text>
            )}
          </Flex>
        )}
      />
    </Card>
  );
};

export default StatisticCard;
